import LineDataset from './line';
import { extend2, pluck, pluckNumber, getValidValue, getFirstColor,
  parseUnsafeString, parseTooltext, getDashStyle } from '../lib/lib';

let PLOTBORDERCOLOR = 'plotBorderColor',
  SHOWSHADOW = 'showShadow',
  UNDEF,
  math = Math,
  mathMin = math.min,
  mathMax = math.max,
  mathAbs = math.abs,
  HUNDREDSTRING = '100';

class ParetoLineDataset extends LineDataset {
  configureAttributes (datasetJSON) {
    if (!datasetJSON) {
      return false;
    }
    this.trimData(datasetJSON);
    this.config.JSONData = datasetJSON;
    var dataSet = this,
      chart = dataSet.getFromEnv('chart'),
      conf = dataSet.config,
      xAxis = dataSet.getFromEnv('xAxis'),
      JSONData = conf.JSONData,
      setDataArr = JSONData.data,
      setDataLen = setDataArr && setDataArr.length,
      len = setDataLen,
      chartAttr = dataSet.getFromEnv('chart-attrib'),
      colorM = dataSet.getFromEnv('color-manager'),
      showTooltip = pluckNumber(chartAttr.showtooltip, 1),
      yAxisName = parseUnsafeString(chartAttr.yaxisname),
      xAxisName = parseUnsafeString(chartAttr.xaxisname),
      formatedVal,
      parserConfig,
      setTooltext,
      macroIndices,
      toolText,
      isRoundEdges,
      setData,
      setValue,
      dataObj,
      config,
      dataStore = dataSet.components.data,
      numberFormatter = dataSet.getFromEnv('number-formatter'),
      is3D = chart.config.is3D,
      enableAnimation,
      lineDashStyle,
      i,
      maxValue = -Infinity,
      minValue = +Infinity,
      displayValuePercent,
      sumValue = 0,
      value,
      catObj,
      cleanArr = [],
      cumulativeSumValue = 0,
      tooltipSepChar = conf.tootipSepChar = pluck(chartAttr.tooltipsepchar, ', '),
      anchorProps;

    conf.defaultPadding = {
      left: 0.5,
      right: 0.5
    };
    conf.enableAnimation = enableAnimation = pluckNumber(chartAttr.animation,
      chartAttr.defaultanimation, 1);
    conf.animation = !enableAnimation ? false : {
      duration: pluckNumber(chartAttr.animationduration, 1) * 1000
    };
    conf.showTooltip = pluckNumber(chartAttr.showtooltip, 1);
    conf.valuePadding = pluckNumber(chartAttr.valuepadding, 2);
    conf.rotateValues = pluckNumber(chartAttr.rotatevalues) ? 270 : 0;
    conf.showHoverEffect = pluckNumber(chartAttr.plothovereffect,
      chartAttr.showhovereffect, UNDEF);
    conf.showShadow = (isRoundEdges || is3D) ? pluckNumber(chartAttr.showshadow, 1) :
      pluckNumber(chartAttr.showshadow, colorM.getColor(SHOWSHADOW));
    conf.useDataPlotColorForLabels =
                  pluckNumber(chartAttr.usedataplotcolorforlabels, 0);
    conf.use3dlineshift = pluckNumber(chartAttr.use3dlineshift, chart.use3dlineshift);
    // Line configuration attributes parsing
    conf.drawLine = 1;
    conf.linecolor = getFirstColor(pluck(chartAttr.linecolor, colorM.getColor(PLOTBORDERCOLOR)));
    conf.linethickness = pluckNumber(chartAttr.linethickness, 2);
    conf.linealpha = pluck(chartAttr.linealpha, HUNDREDSTRING);
    conf.linedashed = pluckNumber(chartAttr.linedashed, 0);
    conf.linedashlen = pluckNumber(JSONData.linedashlen, chartAttr.linedashlen, 5);
    conf.linedashgap = pluckNumber(JSONData.linedashgap, chartAttr.linedashgap, 4);
    lineDashStyle = getDashStyle(conf.linedashlen, conf.linedashgap);
    conf.lineDashStyle = conf.linedashed ? lineDashStyle : 'none';
    conf.drawanchors = pluckNumber(chartAttr.drawanchors,
      chartAttr.showanchors);
    conf.anchorbgcolor = pluck(chartAttr.anchorbgcolor, colorM.getColor('anchorBgColor'));
    conf.anchorbordercolor = pluck(chartAttr.anchorbordercolor, conf.linecolor);
    conf.anchorradius = pluckNumber(chartAttr.anchorradius, 3);
    conf.anchoralpha = pluck(chartAttr.anchoralpha);
    conf.anchorbgalpha = pluck(chartAttr.anchorbgalpha, 100);
    conf.anchorborderthickness = pluck(chartAttr.anchorborderthickness, 1);
    conf.anchorsides = pluck(chartAttr.anchorsides, 0);
    // Anchor image cosmetics attributes
    conf.anchorimageurl = pluck(chartAttr.anchorimageurl);
    conf.anchorimagealpha = pluckNumber(chartAttr.anchorimagealpha, 100);
    conf.anchorimagescale = pluckNumber(chartAttr.anchorimagescale, 100);
    conf.anchorimagepadding = pluckNumber(chartAttr.anchorimagepadding, 1);
    conf.anchorstartangle = pluckNumber(chartAttr.anchorstartangle, 90);
    conf.parentYAxis = 1;
    conf.valuePosition = pluck(chartAttr.valueposition, 'auto');
    conf.showvalues = conf.showValues = pluckNumber(chartAttr.showlinevalues, chartAttr.showvalues, 1);

    dataSet.setState('visible', pluckNumber(JSONData.visible, 1) === 1);
    dataSet.setState('dirty', true);

    conf.shadow = {
      opacity: conf.showShadow ? conf.linealpha / 100 : 0
    };

    conf.showCumulativeLine = pluckNumber(chartAttr.showcumulativeline, 1);
    conf.maxRadius = -Infinity;

    if (!dataStore) {
      dataStore = dataSet.components.data = [];
    }
    // Get the sum value and create the clean Array of value
    for (i = 0; i < len; i++) {
      value = mathAbs(numberFormatter.getCleanValue(setDataArr[i].value));
      sumValue += value;
      cleanArr[i] = extend2({}, setDataArr[i]);
      cleanArr[i].value = value;
    }
    // Sort the clean Array of values
    cleanArr.sort(function (a, b) {
      return b.value - a.value;
    });

    conf.imageCount = 0;
    // Parsing the attributes and values at set level.
    for (i = 0; i < len; i++) {
      setData = cleanArr[i];
      dataObj = dataStore[i];
      if (!dataObj) {
        dataObj = dataStore[i] = {
          graphics: {}
        };
      }
      if (!dataObj.config) {
        config = dataStore[i].config = {};
      }
      setValue = mathAbs(numberFormatter.getCleanValue(setData.value));
      if (setValue === null) {
        continue;
      }
      config = dataObj && dataObj.config;
      catObj = xAxis.getLabel(i);
      config.label = getValidValue(parseUnsafeString(pluck(catObj.label)));
      config.showValue = pluckNumber(setData.showvalue, conf.showValues);
      config.setValue = setValue;
      config.setLink = pluck(setData.link);
      config.setDisplayValue = parseUnsafeString(setData.displayvalue);
      cumulativeSumValue += config.setValue;

      setValue = config.setValue = (cumulativeSumValue / sumValue) * 100;
      displayValuePercent = numberFormatter.percentValue(setValue);
      config.toolTipValue = displayValuePercent;
      config.displayValue = displayValuePercent;
      config.valuePosition = pluck(setData.valueposition, conf.valuePosition);
      config.anchorProps = this._parseAnchorProperties(i, cleanArr);
      config.hoverEffects = this._parseHoverEffectOptions(dataObj);
      anchorProps = config.anchorProps;
      conf.maxRadius = Math.max(conf.maxRadius,
        anchorProps.radius + anchorProps.borderThickness / 2);
      config._x = i;
      config._y = setValue;
      // setTooltext = config.setTooltext = getValidValue(parseUnsafeString(
      //     pluck(setData.cumulativeplottooltext, chartAttr.cumulativeplottooltext)));

      formatedVal = config.toolTipValue;
      maxValue = mathMax(maxValue, setValue);
      minValue = mathMin(minValue, setValue);
      // Parsing tooltext against various configurations provided by the user.
      if (!showTooltip) {
        toolText = false;
      } else {
        if (!conf.showTooltip) {
          toolText = false;
        } else if (setTooltext !== UNDEF) {
          parserConfig = {
            formattedValue: formatedVal,
            label: config.label,
            yaxisName: yAxisName,
            xaxisName: xAxisName,
            cumulativeValue: cumulativeSumValue,
            cumulativeDataValue: numberFormatter.dataLabels(cumulativeSumValue),
            cumulativePercentValue: displayValuePercent,
            sum: numberFormatter.dataLabels(sumValue),
            unformattedSum: sumValue
          };
          macroIndices = [1, 2, 3, 5, 6, 7, 20, 21, 22, 23, 24, 25];
          toolText = parseTooltext(setTooltext, macroIndices, parserConfig, setData,
            chartAttr);
        } else { // determine the dispalay value then
          toolText = config.label ? config.label + tooltipSepChar + config.toolTipValue : '';
        }
        config.toolText = toolText;
      }
      config.toolText = toolText;
      config.tooltext = setTooltext;
      config.setTooltext = toolText;
    }
    conf.maxValue = maxValue;
    conf.minValue = minValue;
  }
}
export { ParetoLineDataset };
